<template>
  <div style="margin-bottom:50px;">
    <Title
      :pages="[{ icon: 'building', page: page_title.toUpperCase() }]"
    ></Title>

    <div
      style="padding:20px;margin-top:50px"
      v-if="list_access || create_access"
    >
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.key">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          @click="tab = 0"
          key="0"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <Company></Company>
        </v-tab-item>
        <v-tab-item
          @click="tab = 1"
          key="1"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <CompanyType></CompanyType>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Company from "./Company";
import CompanyType from "../CompanyType/CompanyType";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
export default {
  components: {
    Title,
    Company,
    CompanyType,
  },
  mixins: [RolMixin],
  data() {
    return {
      page_title: this.$t("Empresas"),
      tab: 0,
      items: [
        { tab: this.$t("Empresas"), key: "0" },
        { tab: this.$t("Tipos_empresa"), key: "1" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
